export const EDUCATOR_LANDING_SEO_DESCRIPTION =
  'A ready-to-teach online safety curriculum for Grades 4-6. No prep — students play, you get classroom dashboards. Try it free with your class.'

export const PUBLIC_PAGE_SEO = {
  home: {
    title: 'Online Safety Education for Kids',
    description:
      'Digipalz teaches kids online safety, digital literacy, and cyber awareness through fun, interactive lessons, quizzes, and games. Trusted by parents, teachers, and schools.',
    url: '/',
    h1: 'Digipalz — Online Safety Education for Kids'
  },
  pricing: {
    title: 'Pricing — Family Plans',
    description:
      'Choose the right Digipalz plan for your family. Affordable monthly and annual subscriptions for parents teaching kids online safety.',
    url: '/pricing'
  },
  aboutUs: {
    title: 'About Digipalz | Online Safety Education for Kids',
    description:
      'Meet the team behind Digipalz. We build game-based online safety education for kids 8-12, working with parents, teachers, and schools in the US and Canada.',
    exactTitle: true,
    url: '/about-us'
  },
  educatorLanding: {
    title: 'Online Safety Curriculum for Schools & Educators',
    description: EDUCATOR_LANDING_SEO_DESCRIPTION,
    url: '/educator-landing'
  },
  contactUs: {
    title: 'Contact Us',
    description:
      'Get in touch with the Digipalz team for support, partnerships, or questions about online safety education for kids.',
    url: '/contact-us'
  },
  articles: {
    title: 'Articles & Resources',
    description:
      'Browse Digipalz articles and resources on digital citizenship, classroom safety, and teaching kids to stay safe online.',
    url: '/articles'
  },
  faqs: {
    title: 'FAQs — Help Center',
    description:
      "Find answers to common questions about Digipalz. Learn how online safety lessons work, how to manage your child's account, and how schools can get started.",
    url: '/faqs'
  },
  accessibility: {
    title: 'Accessibility Statement',
    description:
      'Digipalz accessibility statement — our commitment to making online safety education accessible to everyone.',
    url: '/accessibility'
  },
  privacy: {
    title: 'Privacy Policy',
    description:
      'Digipalz Privacy Policy for adult users — how we collect, use, and protect personal information in the United States and Canada.',
    url: '/privacy-policy-en'
  },
  childPrivacy: {
    title: "Children's Privacy Policy",
    description:
      "Digipalz Children's Privacy Policy — how we collect, use, and protect children's and students' information in compliance with COPPA, FERPA, and PIPEDA.",
    url: '/children-privacy-policy-en'
  },
  terms: {
    title: 'Terms of Service',
    description:
      'Digipalz Terms of Service — terms and conditions for using the Digipalz educational platform, subscriptions, and services in the United States and Canada.',
    url: '/terms-of-service-en'
  },
  cookie: {
    title: 'Cookie Policy',
    description:
      'Digipalz Cookie Policy — how we use cookies and similar technologies on our website and platform.',
    url: '/cookie-policy-en'
  },
  dataRetention: {
    title: 'Data Retention Policy',
    description:
      'Digipalz Data Retention Policy — how long we retain personal information and when we delete or de-identify it.',
    url: '/data-retention-policy-en'
  }
}
